<template>
  <div>
    <b-row>
      <b-col sm="12" md="12">
        <b-card no-body>
          <b-card-header>
            <h3 class="float-left"><i class='fa fa-cogs'></i> System Config Settings</h3>
          </b-card-header>
          <b-card-body>
            <div class="overflow-auto">
              <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage">
                <template v-slot:cell(Value)="data">
                  <p-input v-if="data.item._editable" v-model.trim="form.value" name="value" :handler="$v" :formData="form" type="text"/>
                  <span v-else>{{ data.item.Value }}</span>
                </template>
                <template v-slot:cell(Action)="data" v-if="checkAccessPrivilege('System.Config.Update')">
                  <template v-if="data.item._editable">
                    <b-button variant="success" class="btn-sm" @click="save(data.item)"><i class="icons icon-check"></i> Save</b-button>
                    <b-button variant="danger" class="btn-sm" @click="cancel(data.item)"><i class="icons icon-cancel"></i> Cancel</b-button>
                  </template>
                  <b-button v-else variant="warning" class="btn-sm" @click="edit(data.item)"><i class="icons icon-pencil"></i> Edit</b-button>
                </template>
              </b-table>
              <nav>
                <b-pagination :total-rows="getRowCount(items)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
              </nav>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {Events} from '../../events.js'
import {PInput} from '../../components'
const {required} = require('vuelidate/lib/validators')

export default {
  name: 'payment-settings',
  props: {
    caption: {
      type: String,
      default: 'Table'
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      items: [],
      fields: [
        {key: 'Label', value: 'Name', sortable: true, thStyle: { width: '500px' }},
        {key: 'Value', value: 'Value'},
        {key: 'Action', value: 'Action', thStyle: { width: '150px' }}
      ],
      form: {
        code: '',
        value: '',
        errorMessages: {
          value: {
            required: 'Value must not be empty'
          }
        }
      },
      currentPage: 1,
      perPage: 50
    }
  },
  components: {
    PInput
  },
  validations: {
    form: {
      value: {
        required
      }
    }
  },
  methods: {
    getRowCount (item) {
      return item.length
    },
    async getPaymentSetting () {
      try {
        Events.$emit('loader')
        let { data } = await this.$http.get(this.API_ENDPOINT + '/system/config/getList', { headers: { 'Content-Type': 'application/json' } })
        this.items = data
      } catch (err) {
        let e = err.response.data
        let code = e.code
        let msg = e.msg
        Events.$emit('alert', 'error', code, msg)
      } finally {
        Events.$emit('loader')
      }
    },
    edit (item) {
      this.items.forEach(x => { this.$set(x, '_editable', false) })
      this.$set(item, '_editable', true)
      this.form.code = item.Parameter
      this.form.value = item.Value
    },
    async save (item) {
      try {
        Events.$emit('loader')
        this.$v.form.$touch()
        if (this.$v.form.$error) {
          return true
        }
        let requestBody = {
          parameter: this.form.code,
          value: this.form.value
        }
        await this.$http.post(this.API_ENDPOINT + '/system/config/update', requestBody, { headers: { 'Content-Type': 'application/json' } })
        Events.$emit('alert', 'success', 'Success', 'Payment Settings Updated Successfully')
        item.Value = this.form.value
        this.cancel(item)
      } catch (err) {
        let e = err.response.data
        let code = e.code
        let msg = e.msg
        Events.$emit('alert', 'error', code, msg)
      } finally {
        Events.$emit('loader')
      }
    },
    cancel (item) {
      this.$v.form.$reset()
      this.form.code = ''
      this.form.value = ''
      this.$delete(item, '_editable')
    },
    checkAccessPrivilege (module, title = false) {
      if (!module) return true
      if (title) return (JSON.stringify(this.PRIVILEGE).includes(module))
      return this.PRIVILEGE.includes(module)
    }
  },
  created () {
    this.getPaymentSetting()
  }
}
</script>


// WEBPACK FOOTER //
// src/views/systemConfig/SystemConfigTable.vue